// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__3-2Yi","header":"Graph_header__OsD5v","options":"Graph_options__2b5ze"};